import { mutateGraphQL, queryGraphQL } from 'common/util/query';
import { toMutation, nodeWithArgs, toQuery, } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
export const ADD_OR_MODIFY_STUDY_TESTAMENT = 'ADD_OR_MODIFY_STUDY_TESTAMENT';
export const GET_ALL_STUDY_TEMPLATES_FOR_INSTITUTION = 'GET_ALL_STUDY_TEMPLATES_FOR_INSTITUTION';
export const ADD_OR_MODIFY_STUDY_TEMPLATE = 'ADD_OR_MODIFY_STUDY_TEMPLATE';
export const UPDATE_CENTRALIZED_PROPERTY = 'UPDATE_CENTRALIZED_PROPERTY';

export function addOrModifyStudyTestament(testament) {
    return (dispatch) => {
        const query = nodeWithArgs('addOrModifyStudyTestament', {
            testament,
        }, [
            'id',
            'title',
            'text',
        ]);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add or modify study testament'));
            } else {
                dispatch({
                    type: ADD_OR_MODIFY_STUDY_TESTAMENT,
                    payload: results.data.addOrModifyStudyTestament,
                });
                if(testament.id){
                    dispatch(addApplicationMessage('success', 'Testament has been modified successfully'));
                }
                else{
                    dispatch(addApplicationMessage('success', 'Testament has been added successfully'));
                }
            }
        });
    };
}

export function addOrModifyStudyTemplate(template) {
    return (dispatch) => {
        const query = nodeWithArgs('addOrModifyStudyTemplate', {
            template,
        }, [
            'id',
            'templateName',
            'taskNames',
        ]);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add study template'));
            } else {
                dispatch(addApplicationMessage('success', 'Study template has been updated successfully.'));
                dispatch({
                    type: ADD_OR_MODIFY_STUDY_TEMPLATE,
                    payload: results.data.addOrModifyStudyTemplate,
                });
            }
        });
    };
}

export function getAllStudyTemplatesForInstitution(institutionId){
    return (dispatch) => {
        const query = nodeWithArgs('studyTemplates', {
            institutionId,
        }, [
            'id',
            'templateName',
            'taskNames',
        ],);
        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve study testaments'));
            } else {
                dispatch({
                    type: GET_ALL_STUDY_TEMPLATES_FOR_INSTITUTION,
                    payload: results.data.studyTemplates,
                });
            }
        });
    };
}

export function updateCentralizedProperty(property, institutionId, sub){
    return (dispatch) => {
        const query = nodeWithArgs('updateCentralizedProperty', {
            institutionId,
            property,
            sub,
        }, ['id',
            'institutionId',
            'type',
            'value',
            'options',
        ],);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to update institution property'));
            } 
            else {
                dispatch(addApplicationMessage('success', 'Signature collection type has been updated.'));
                dispatch({
                    type: UPDATE_CENTRALIZED_PROPERTY,
                });
            }
        });
    };
}
